/**
 * PROSHOP — Favoris (cœur card produit).
 *
 * Toggle léger côté client (localStorage), sans backend ni plugin.
 * Quand une vraie wishlist (plugin) sera branchée, remplacer la persistance ici.
 * Un fichier par fonctionnalité (convention projet, cf. utilities/nx_*.js sur next-you).
 */
const STORAGE_KEY = 'ps_wishlist';

const read = () => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
        return [];
    }
};

const write = (ids) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
        /* stockage indisponible : on ignore silencieusement */
    }
};

// Badge compteur dans le header (présent sur toutes les pages).
const updateCount = () => {
    const n = read().length;
    document.querySelectorAll('.pdw-wishlist-count').forEach((badge) => {
        badge.textContent = n;
        badge.hidden = n === 0;
    });
};

document.addEventListener('DOMContentLoaded', () => {
    updateCount();

    const buttons = document.querySelectorAll('.pdw-product-card-wishlist');
    if (!buttons.length) {
        return;
    }

    let ids = read();

    buttons.forEach((btn) => {
        const id = btn.dataset.productId;
        if (id && ids.includes(id)) {
            btn.classList.add('is-active');
            btn.setAttribute('aria-pressed', 'true');
        }

        btn.addEventListener('click', () => {
            if (!id) {
                return;
            }
            ids = read();
            const i = ids.indexOf(id);
            if (i === -1) {
                ids.push(id);
                btn.classList.add('is-active');
                btn.setAttribute('aria-pressed', 'true');
            } else {
                ids.splice(i, 1);
                btn.classList.remove('is-active');
                btn.setAttribute('aria-pressed', 'false');
            }
            write(ids);
            updateCount();
        });
    });
});
